import * as pluralize from 'pluralize'
import * as React from 'react'
import { Site } from '../../../../../common/constants/siteList'
import { commaStyleString } from '../../../../../common/utils/formatString'
import { getConfigBySite } from '../../../../../config/sites'

import * as styles from './searchResultsCountLabel.module.css'

interface IProps {
  term: string
  hits: number
  currentSite: Site
  hasSelectedCategory: boolean
}

const SearchResultsCountLabel: React.StatelessComponent<IProps> = props => {
  const { term, hits, currentSite, hasSelectedCategory } = props
  const assetType = getConfigBySite(currentSite, 'asset_type')

  return (
    <p className={styles.seoHeader}>
      <span className={styles.count}>{commaStyleString(hits, ',') + ' '}</span>
      {term && (
        <span className={styles.seoHeaderTerm}>&apos;{term}&apos;</span>
      )}{' '}
      {pluralize(assetType, hits)}
      {hasSelectedCategory && ' in'}
    </p>
  )
}

export default SearchResultsCountLabel
